module.exports = __webpack_public_path__ + "img/modules-05.268e38c9.svg";